import React from 'react'
import { NutritionMeal } from '@store/Nutrition/types'
import MealDetails from './meal-details'
import './meals.css'

interface MealsProps {
  meals: NutritionMeal[]
}

function Meals({ meals }: MealsProps) {
  return (
    <div className='meals'>
      {meals.map((meal, index) => (
        <div key={index} className='meals__section'>
          <h3 className='meals__title'>{meal.meal_type}</h3>
          <MealDetails items={meal.items} />
        </div>
      ))}
    </div>
  )
}

export default Meals
